import { os } from './utils';
/**
 * js与native交互的方法，事件队列处理等逻辑
 */
class SuperAppBridgeClass {
    constructor(bridge, eventNames, onSubEvents) {
        // 监听原生方法的事件
        this.registerEvents = new Map();
        // 可监听的方法名
        this._eventNames = [];
        // 记录调用方法的数量，生成事件唯一id 
        this.eventNum = 0;
        this.bridge = bridge;
        this._eventNames = eventNames.concat('registerHandlerWithCallback');
        try {
            // Native2JSInteraction 
            // native透传uniapp调用H5方法，使用 bridge.registerHandler 来调用监听从uniapp传过来的数据（如onLogin、onShow等）
            this.bridge.registerHandler('Native2JSInteraction', (responseData, responseCallback) => {
                const { rel, data } = responseData;
                let _rel = rel, _data = data;
                // 兼容安卓无法转发 callback 的情况
                if (_rel === 'registerHandlerWithCallback') {
                    _rel = _data.rel;
                    _data = _data.data;
                }
                // 返回订阅事件
                if (onSubEvents) {
                    onSubEvents && onSubEvents(_rel, _data);
                }
                if (this.registerEvents.has(_rel)) {
                    this.registerEvents.get(_rel).forEach((callback) => {
                        if (typeof callback === 'function') {
                            callback(_data, responseCallback);
                        }
                    });
                }
                // if (~this._eventNames.indexOf(_rel)) {
                // }
            });
        }
        catch (error) {
            console.error(error);
        }
    }
    // 实时添加可监听的事件名
    appendEventNames(eventNames) {
        if (Array.isArray(eventNames)) {
            this._eventNames = this._eventNames.concat(eventNames);
        }
    }
    addBridgeListener(eventName, callback) {
        let callbacks = this.registerEvents.get(eventName) || [];
        this.registerEvents.set(eventName, [...callbacks, callback]);
    }
    removeBridgeListener(eventName, callback) {
        if (this.registerEvents.has(eventName)) {
            let callbacks = this.registerEvents.get(eventName) || [];
            let callbackIndex = callbacks.indexOf(callback);
            if (~callbackIndex) {
                callbacks.splice(callbackIndex, 1);
            }
            this.registerEvents.set(eventName, callbacks);
        }
    }
    callHandler(eventName, data, withCallback) {
        try {
            if (os.isAndroid && withCallback) {
                return new Promise((resolve, reject) => {
                    let handlerId = eventName + (+new Date()) + ('' + this.eventNum++);
                    let callback = (res) => {
                        if (!res) {
                            reject(res);
                        }
                        else {
                            resolve(res);
                        }
                        this.removeBridgeListener(handlerId, callback);
                    };
                    this.addBridgeListener(handlerId, callback);
                    this.bridge.callHandler('JS2NativeInteraction', {
                        rel: 'callHandlerWithCallback',
                        data: {
                            rel: eventName,
                            data: data,
                            handlerId,
                        }
                    });
                });
            }
            // JS2NativeInteraction
            // native透传H5调用uniapp方法，使用bridge.callHandler调用
            return new Promise((resolve, reject) => {
                this.bridge.callHandler('JS2NativeInteraction', {
                    rel: eventName,
                    data: data
                }, (res) => {
                    if (!res) {
                        reject(res);
                    }
                    else {
                        resolve(res);
                    }
                });
            });
        }
        catch (error) {
            console.error(error);
            return false;
        }
    }
}
/**
 *  初始化bridge的方法，监听桥接成功后进行初始化回调
 *  @param callback {Function} 回调函数
 *  iOS需主动请求https://__bridge_loaded__来触发连接的建立，成功后即执行WVJBCallbacks中的所有回调；
 *  安卓会在桥接完成后触发WebViewJavascriptBridgeReady自定义事件，需H5自己执行WVJBCallbackQueue的所有回调
 *  需执行window.WebViewJavascriptBridge.init()才能开始通信，init只能执行一次
 */
function setupWebViewJavascriptBridge(callback) {
    if (os.isIOS) {
        if (window.WebViewJavascriptBridge) {
            return callback(window.WebViewJavascriptBridge);
        }
        if (window.WVJBCallbacks) {
            return window.WVJBCallbacks.push(callback);
        }
        window.WVJBCallbacks = [callback];
        var WVJBIframe = document.createElement('iframe');
        WVJBIframe.style.display = 'none';
        WVJBIframe.src = 'https://__bridge_loaded__';
        document.documentElement.appendChild(WVJBIframe);
        setTimeout(function () { document.documentElement.removeChild(WVJBIframe); }, 0);
    }
    else if (os.isAndroid) {
        // 安卓也有可能未获取的window.WebViewJavascriptBridge对象，目前暂时用延时来获取
        setTimeout(function () {
            if (window.WebViewJavascriptBridge) {
                callback(window.WebViewJavascriptBridge);
            }
            else {
                if (window.WVJBCallbackQueue) {
                    window.WVJBCallbackQueue.push(callback);
                }
                else {
                    window.WVJBCallbackQueue = [callback];
                }
                document.addEventListener('WebViewJavascriptBridgeReady', function () {
                    if (!setupWebViewJavascriptBridge.registered) {
                        setupWebViewJavascriptBridge.registered = true;
                        let cbQueue = window.WVJBCallbackQueue;
                        for (let i = 0; i < cbQueue.length; i++) {
                            cbQueue[i](window.WebViewJavascriptBridge);
                        }
                    }
                }, false);
            }
        }, 0);
    }
}
export { SuperAppBridgeClass, setupWebViewJavascriptBridge };
//# sourceMappingURL=index.js.map